import { Component, ChangeDetectionStrategy, Input, inject, Output, EventEmitter } from '@angular/core';
import { TuiDialogContext, TuiDialogService, TuiSizeS } from '@taiga-ui/core';
import { PolymorpheusContent } from '@taiga-ui/polymorpheus';

@Component({
  selector: 'app-preview-button',
  templateUrl: './preview-button.component.html',
  styleUrls: ['./preview-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewButtonComponent {
  private readonly dialogService = inject(TuiDialogService);

  @Input() contextTemplate?: PolymorpheusContent<TuiDialogContext>;
  @Input() size: TuiSizeS = 'm';
  @Output() openChanges: EventEmitter<boolean> = new EventEmitter();

  showPreview(click: MouseEvent) {
    if (this.contextTemplate) {
      click.stopPropagation();

      this.dialogService
        .open(this.contextTemplate, {
          closeable: true,
          dismissible: true,
        })
        .subscribe();
    }
  }
}
